import React from "react"
import { Link } from "gatsby"

import Seo from "../../components/seo"
import HeroInner from "../../components/heroinner"
// import StatutoryCompliancePic from "../../static/images/Statutory-Compliance.png"

export default function Statutory() {
  const heroTitle = "PMS"
  const heroImage = "/images/slider/Services--Banner.jpg"
  const heroMobileImage = "/images/slider/mobile/Services--Banner.jpg"
  const breadcrumbSecondaryItem = "Statutory"
  const breadcrumbSecondaryItemUrl = "/statutory/ria"

  return (
    <>
      <Seo title={heroTitle} />
      <HeroInner
        heroTitle={heroTitle}
        breadcrumbSecondaryItem={breadcrumbSecondaryItem}
        breadcrumbSecondaryItemUrl={breadcrumbSecondaryItemUrl}
        heroImage={heroImage}
        heroMobileImage={heroMobileImage}
      />
      <section class="c-section c-section-sm">
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-3 col-md-4 order1">
              <Link to="/" className="back--home">
                <i class="fas fa-chevron-left"></i> <span>Home</span>
              </Link>
            </div>

            <div class="col-12 col-lg-9 col-md-8 order2">
              <div class="innerpage--content innerpage--content-sm">
                <h2 class="h2 h2-sm">{heroTitle}</h2>
                <ul>
                  <li>
                    <a href="/docs/Disclosure_Document_Jan_2026.pdf" target="_blank" rel="noopener">
                      Disclosure Document
                    </a>
                  </li>
                  <li>
                    <a
                      href="/docs/Investor_Charter_(Annexure A)_Jul_2026.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Investor Charter (Annexure A)
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://docs.google.com/document/d/1GwL3OuBKjnhn5ycynGeuXbKnRlq70Oi2GYULCBjN6a8/export?format=pdf&rel=MonthlyDisclosureOfInvestorComplaints.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Monthly Disclosure of Investor Complaints (Annexure B)
                    </a>
                  </li>
                  <li>
                    <a
                      href="/docs/Fee_Calculator_for_Portfolio_V2.xlsx"
                      target="_blank"
                      rel="noopener"
                    >
                      Fee Calculator
                    </a>
                  </li>
                  <li>
                    <a
                      href="/docs/Complaints_Redressal_(Annexure C).pdf"
                      target="_blank"
                      rel="noopener"
                    >
                      Complaint Redressal (Annexure C)
                    </a>
                  </li>
                  <li>
                    <a
                      href="/docs/Framework_for_Accredited_Investor.pdf"
                      target="_blank"
                      rel="noopener"
                    >
                      Framework for Accredited Investors (Annexure D)
                    </a>
                  </li>
                  <li>
                    <a href="/docs/UPI_Details_for_PMS.pdf" target="_blank" rel="noopener">
                      UPI Details
                    </a>
                  </li>
                </ul>
                <p className="mb-4">
                  <strong>PMS Direct Client onboarding</strong>
                  <br />
                  For direct onboarding as a PMS investor with us, please connect with us at:
                  <br />
                  Email: <a href="mailto:vikrant@apricuswealth.in">vikrant@apricuswealth.in</a>
                  <br />
                  Contact number: <a href="tel:+919810302008">+91 98103 02008</a>
                </p>
                {/* <img src={StatutoryCompliancePic} alt="Statutory Compliance" class="img-fluid" /> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
